"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var reportApi = exports.reportApi = {
  date: function date(params) {
    return (0, _request.default)({
      url: "/report/date",
      params: params
    });
  },
  week: function week(params) {
    return (0, _request.default)({
      url: "/report/week",
      params: params
    });
  },
  month: function month(params) {
    return (0, _request.default)({
      url: "/report/month",
      params: params
    });
  }
};